import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Helmet from 'react-helmet';

class ModalLayout extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
    };
    this.timeout = null;
    this.back = this.back.bind(this);
  }

  componentDidMount() {
    this.setState({ isActive: true });
  }

  componentDidUpdate() {
    const { isActive } = this.state;

    if (isActive) {
      document.documentElement.classList.add('overflow-hidden');
    } else {
      document.documentElement.classList.remove('overflow-hidden');
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  back(e) {
    e.stopPropagation();
    const { history } = this.props;
    const transition = () => {
      history.goBack();
      clearTimeout(this.timeout);
    };

    this.setState({ isActive: false });
    this.timeout = setTimeout(transition, 375);
  }

  render() {
    const { children } = this.props;
    const { isActive } = this.state;

    return (
      <>
        <Helmet>
          <meta name="theme-color" content="#161616" />
        </Helmet>
        <div
          className={`ModalLayout ${
            isActive ? 'ModalLayout--active' : ''
          }`}
        >
          <div className="ModalLayout__container">
            {children}
          </div>
          <button
            type="button"
            className="ModalLayout__overlay"
            onClick={this.back}
          >
            Voltar
          </button>
        </div>
      </>
    );
  }
}

ModalLayout.propTypes = {
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
  }).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.func,
  ]).isRequired,
};

export default withRouter(ModalLayout);
